import * as React from "react";
import { useField } from "formik";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import HandleError from "../HandleError";

export default function Checkout({ name, label, ...props }) {
  const [field] = useField({ name, ...props });
  return (
    <FormGroup>
      <FormControlLabel
        control={<Checkbox {...field} {...props} />}
        label={label}
      />
      <HandleError name={name} />
    </FormGroup>
  );
}
